import React, { useState, useEffect } from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '../context/CookieConsentContext';
import { IS_PRERENDERING } from '../utils/config';
import './CookieConsent.css';

const CookieConsent = () => {
  // console.log(`[CookieConsent] Component start`);
  const { hasMadeChoice, updateConsent, openSettings } = useCookieConsent();
  const lang = useLanguage();
  const { t } = useTranslation();

  // This state ensures we don't render the banner on the initial client render,
  // matching the server-rendered output (which is null).
  const [isClient, setIsClient] = useState(false);

  // This effect will only run on the client, after the initial render.
  useEffect(() => {
    // console.log(`[CookieConsent] useEffect running.`);

    // Do not run this effect during the pre-render process.
    if (!IS_PRERENDERING) {
      // console.log(`[CookieConsent] useEffect running, setting isClient to true.`);
      setIsClient(true);
    }
  }, []);

  const handleCustomize = () => {
    openSettings();
  };

  // On the server, and on the initial client render, `isClient` is false, so we render nothing.
  // This guarantees the server and client HTML match, preventing a hydration error.
  // After hydration, `isClient` becomes true, and we then check `hasMadeChoice`.
  // console.log(`[CookieConsent] Rendering. isClient: ${isClient}, hasMadeChoice: ${hasMadeChoice}`);
  if (!isClient || hasMadeChoice) {
    // console.log(`[CookieConsent] Component end: Rendering null.`);
    return null;
  }

  // console.log(`[CookieConsent] Component end: Rendering banner.`);
  return (
    <div className="cookie-consent-banner">
      <p>
        {t('cookieConsent.message')}{' '}
        <a href={`/${lang}/cookie-policy`} target="_blank" rel="noopener noreferrer">
          {t('cookieConsent.cookiePolicyLink')}
        </a>
        .
      </p>
      <div className="cookie-consent-actions">
        <button onClick={handleCustomize} className="cookie-btn customize">
          {t('cookieConsent.customize')}
        </button>
        <button onClick={() => updateConsent('essential')} className="cookie-btn reject">
          {t('cookieConsent.reject')}
        </button>
        <button onClick={() => updateConsent('all')} className="cookie-btn accept">
          {t('cookieConsent.accept')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
